export const toLocaleString = (x: number, decimals: number = 1): string => {
  return x.toLocaleString("en-EN", {
    style: "decimal",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};
